import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ksPetitesAnnoncesQK } from "../query-keys";
import { petitesAnnoncesService } from "../services/petites-annonces.service";
import {
  CalculerPrixPayload,
  CalculerPrixResult,
  CreatePetiteAnnoncePayload,
  CreatePetiteAnnonceResult,
  CreatePetiteAnnonceStripeSessionResult,
  PetiteAnnonceResult,
} from "../interfaces/petites-annonces.interface";

type QueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

export const usePetitesAnnonces = () => {
  return useQuery({
    queryKey: [ksPetitesAnnoncesQK],
    queryFn: petitesAnnoncesService.findAll,
  });
};

export const usePetiteAnnonce = (
  id: string,
  options?: QueryOptions<PetiteAnnonceResult>
) =>
  useQuery({
    queryKey: [ksPetitesAnnoncesQK, id],
    queryFn: () => petitesAnnoncesService.findById(id),
    ...options,
  });

export const useDeletePetiteAnnonce = () =>
  useMutation({
    mutationFn: petitesAnnoncesService.remove,
  });

export const useCreatePetiteAnnonce = () =>
  useMutation<CreatePetiteAnnonceResult, Error, CreatePetiteAnnoncePayload>({
    mutationFn: petitesAnnoncesService.create,
  });

export const useCreatePetiteAnnonceStripeSession = () =>
  useMutation<CreatePetiteAnnonceStripeSessionResult, Error, string>({
    mutationFn: petitesAnnoncesService.createStripeSession,
  });

export const useCalculerPrixPetiteAnnonce = (
  payload: CalculerPrixPayload,
  options?: QueryOptions<CalculerPrixResult>
) =>
  useQuery({
    queryKey: [ksPetitesAnnoncesQK, "prix", payload],
    queryFn: () => petitesAnnoncesService.calculerPrix(payload),
    refetchOnWindowFocus: false,
    ...options,
  });
